import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a98447b1742ad0014e90da0_1788590133290_b5ac65ae/footballdash/src/app/sign-up-login-screen/components/AuthScreen.tsx");
